module.exports = __webpack_public_path__ + "static/media/image001.f1265264.jpg";